<template>
  <div>
    <SchemaTablePage
      ref="tablePageRef"
      :search-schema="searchSchema"
      :columns="tableColumns"
      :default-query="defaultQuery"
      :request="request"
      :build-params="buildParams"
      :parse-result="parseResult"
      :table-attrs="tableAttrs"
      :table-listeners="tableListeners"
    >
      <template #search-ip="{ query }">
        <el-input v-model="query.ip" placeholder="输入IP地址" clearable>
          <template #prepend>
            <el-select size="mini" v-model="query.ipType" placeholder="选择IP类型" style="width: 100px">
              <el-option label="登录IP" value="login"></el-option>
              <el-option label="注册IP" value="reg"></el-option>
            </el-select>
          </template>
        </el-input>
      </template>

      <template #search-dateRange="{ query }">
        <DateTimeRangePicker v-model="query.dateRange" size="mini" style="width: 100%">
          <template #prepend>
            <el-select size="mini" v-model="query.timeType" placeholder="选择时间类型" style="width: 100px">
              <el-option label="登录时间" value="login"></el-option>
              <el-option label="注册时间" value="reg"></el-option>
            </el-select>
          </template>
        </DateTimeRangePicker>
      </template>

      <template #memberAccount="{ row }">
        <MemberAccountCell
          :row="row"
          :username="row.username"
          :uid="row.uid"
          :vip-level="row.vip_level"
          @detail-closed="handleRefreshTable"
        />
      </template>
      <template #colPayin="{ row }">
        {{ formatYuan(row.total_payin_amount) }}（{{ row.total_payin_times != null ? row.total_payin_times : '--' }}次）
      </template>
      <template #colPayout="{ row }">
        {{ formatYuan(row.total_payout_amount) }}（{{
          row.total_payout_times != null ? row.total_payout_times : '--'
        }}次）
      </template>
      <template #colDiff="{ row }">
        {{ formatYuan(row.total_payment_win_loss) }}（{{ formatYuan(row.first_payin_amount) }}）
      </template>
      <template #colStatus="{ row }">
        <el-tag size="mini" :type="row.status === 1 ? 'success' : 'danger'">
          {{ row.status === 1 ? '正常' : '停用' }}
        </el-tag>
      </template>
      <template #colLoginInfo="{ row }">
        <div class="login-info-cell">
          <div>{{ row.login_ip || '--' }}</div>
          <div>{{ row.country || '--' }}</div>
        </div>
      </template>
      <template #colActions="{ row }">
        <div class="action-buttons">
          <el-button size="mini" type="text" @click="handleDetail(row)"> 详情 </el-button>
        </div>
      </template>
    </SchemaTablePage>

    <!-- 会员详情弹窗（V2，旧版组件保留未删除） -->
    <MemberDetailDialogV2
      :visible.sync="detailDialogVisible"
      :member-uid="selectedMemberUid"
      :user-info="currentMemberInfo"
    />
  </div>
</template>

<script>
// 引入mock数据
import { MemberApi } from '@/api/member/member'
import SchemaTablePage from '@/components/SchemaTablePage'
import MemberAccountCell from '@/components/MemberAccountCell.vue'
import DateTimeRangePicker from '@/components/DateTimeRangePicker'
import { centsToYuan } from '@/utils/amount'
import { formatTimestamp, toUnixSeconds } from '@/utils/time'
import { omitBy } from 'lodash-es'
import MemberDetailDialogV2 from './components/ManageDetailDialogV2.vue'
import ModifyLoginPasswordDialog from './components/modify-login-password.vue'

const defaultSearchForm = {
  uid: '',
  username: '',
  mobile: '',
  email: '',
  inviter_username: '',
  status: 0,
  vip_level: -1,
  register_type: null,
  inviter_status: 1,
  ipType: 'login',
  ip: '',
  login_device: '',
  vip_tags: '',
  timeType: 'login',
  dateRange: [],
  ads_channel: '',
}

export default {
  name: 'AdminMemberManage',
  components: {
    SchemaTablePage,
    MemberAccountCell,
    DateTimeRangePicker,
    MemberDetailDialogV2,
    ModifyLoginPasswordDialog,
  },
  data() {
    return {
      changeStatus: false,
      defaultQuery: { ...defaultSearchForm },
      tableAttrs: {},
      searchSchema: [
        { prop: 'username', label: '会员账号', component: 'input', componentProps: { clearable: true } },
        { prop: 'uid', label: '会员ID', component: 'input', componentProps: { clearable: true } },
        { prop: 'mobile', label: '手机号码', component: 'input', componentProps: { clearable: true } },
        {
          prop: 'status',
          label: '状态',
          component: 'select',
          componentProps: { clearable: true },
          options: [
            { label: '全部', value: 0 },
            { label: '启用', value: 1 },
            { label: '禁用', value: 2 },
          ],
        },
        {
          prop: 'vip_level',
          label: '会员等级',
          component: 'select',
          componentProps: { clearable: true },
          options: [
            { label: '全部', value: -1 },
            { label: 'VIP0', value: 0 },
            { label: 'VIP1', value: 1 },
            { label: 'VIP2', value: 2 },
            { label: 'VIP3', value: 3 },
            { label: 'VIP4', value: 4 },
            { label: 'VIP5', value: 5 },
            { label: 'VIP6', value: 6 },
            { label: 'VIP7', value: 7 },
            { label: 'VIP8', value: 8 },
            { label: 'VIP9', value: 9 },
          ],
        },
        { prop: 'login_device', label: '登录设备', component: 'input', componentProps: { clearable: true } },
        { prop: 'ads_channel', label: '投放渠道', component: 'input', componentProps: { clearable: true } },
        {
          label: 'IP地址',
          component: 'slot',
          slot: 'search-ip',
          span: { xs: 24, sm: 12, md: 10, lg: 9, xl: 6, xxl: 6 },
        },
        {
          label: '时间范围',
          component: 'slot',
          slot: 'search-dateRange',
          span: { xs: 24, sm: 12, md: 16, lg: 9, xl: 7, xxl: 6 },
        },
        { component: 'actions' },
      ],
      // 选中的行
      selectedRows: [],
      // 详情弹窗可见性
      detailDialogVisible: false,
      // 详情加载状态
      detailLoading: false,
      // 选中的会员信息
      selectedMemberUid: null,
      currentMemberInfo: {},
      tableColumns: [
        // { type: 'selection', width: 45, align: 'center', resizable: false },
        { fixed: 'left', label: '会员账号/ID', minWidth: 160, slot: 'memberAccount' },
        { prop: 'gold', label: '总余额', minWidth: 100 },
        { label: '总充值金额(充值次数)', minWidth: 140, slot: 'colPayin' },
        { label: '总提现金额(提现次数)', minWidth: 140, slot: 'colPayout' },
        { label: '总充提差(首充金额)', minWidth: 140, slot: 'colDiff' },
        { label: '状态', minWidth: 80, slot: 'colStatus' },
        { prop: 'ads_channel', label: '投放渠道', minWidth: 140 },
        { prop: 'created_at', label: '注册时间', minWidth: 140 },
        { label: '最后登录IP/地区 ', minWidth: 240, slot: 'colLoginInfo' },
        { prop: 'login_at', label: '最后登录时间', minWidth: 140 },
        { prop: 'last_bet_time', label: '最后投注时间', minWidth: 140 },
        { prop: 'last_payin_time', label: '最后存款时间', minWidth: 140 },
        { fixed: 'right', label: '操作', width: 80, slot: 'colActions' },
      ],
    }
  },
  computed: {
    tableListeners() {
      return {
        'selection-change': this.handleSelectionChange,
      }
    },
  },
  provide() {
    return {
      MEMBER_INFO_PROVIDER: this,
    }
  },
  watch: {
    detailDialogVisible: {
      handler(newVal) {
        if (!newVal) {
          this.handleRefreshTable()
        }
      },
    },
  },
  methods: {
    request(params) {
      return MemberApi.getList(params)
    },
    buildParams({ query, page, limit }) {
      const params = {
        page,
        page_size: limit,
      }
      const q = omitBy(query || {}, value => value === null || value === '' || value === undefined)
      // 处理时间范围
      if (q.dateRange && q.dateRange.length === 2) {
        if (q.timeType === 'login') {
          q.login_start_at = toUnixSeconds(q.dateRange[0])
          q.login_end_at = toUnixSeconds(q.dateRange[1])
        }

        if (q.timeType === 'reg') {
          q.register_start_at = toUnixSeconds(q.dateRange[0])
          q.register_end_at = toUnixSeconds(q.dateRange[1])
        }
      }

      if (q.ip) {
        if (q.ipType === 'login') {
          q.login_ip = q.ip
        }

        if (q.ipType === 'reg') {
          q.register_ip = q.ip
        }
      }
      delete q.ipType
      delete q.ip
      delete q.timeType
      delete q.dateRange
      return { ...params, ...q }
    },
    mapTableData(data) {
      const timeColumns = ['created_at', 'login_at', 'last_bet_time', 'last_payin_time']
      const amountColumns = [
        'gold',
        // 'total_payin_amount',
        // 'total_payout_amount',
        // 'total_payment_win_loss',
        // 'first_payin_amount',
      ]
      timeColumns.forEach(col => {
        data[col] = this.formatTs(data[col])
      })
      amountColumns.forEach(col => {
        data[col] = this.formatYuan(data[col])
      })
      return { ...data }
    },
    parseResult(response) {
      if (response && response.code === 0) {
        const list = response.data.list.map(this.mapTableData)
        return {
          list: list || [],
          total: (response.data && response.data.total) || 0,
        }
      }
      this.$message.error(response?.msg || '获取会员列表失败')
      return { list: [], total: 0 }
    },

    // 处理行选择变化
    handleSelectionChange(selection) {
      this.selectedRows = selection
    },

    formatYuan(cents) {
      if (cents == null || cents === '') return '--'
      return centsToYuan(cents)
    },
    formatTs(ts) {
      if (ts == null || ts === '' || ts === 0) return '--'
      return formatTimestamp(ts)
    },

    // 查看详情
    async handleDetail(row) {
      this.detailLoading = true
      this.selectedMemberUid = row.uid
      this.currentMemberInfo = row
      this.$nextTick(() => {
        this.detailDialogVisible = true
      })
    },
    handleRefreshTable() {
      if (this.changeStatus) {
        this.$refs.tablePageRef?.reload?.()
        this.changeStatus = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.search-buttons {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.action-buttons {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 4px;
  width: 100%;

  > .el-button {
    margin: 0;
  }
}

.btn-enable {
  color: #67c23a;
}

.btn-disable {
  color: #f56c6c;
}

.login-info-cell {
  font-size: 12px;
  line-height: 1.45;
  text-align: center;
}

.login-info-time {
  color: #606266;
}
</style>
